import { render, staticRenderFns } from "./SubscriptionExtensionComponent.vue?vue&type=template&id=60fd6d80&scoped=true"
import script from "./SubscriptionExtensionComponent.vue?vue&type=script&lang=js"
export * from "./SubscriptionExtensionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd6d80",
  null
  
)

export default component.exports